import styled, { keyframes } from 'styled-components';

export const Dock = styled.div`
  position: fixed;
  top: 56px;
  right: 14px;
  bottom: 14px;
  width: 306px;
  /* порядок наложения задаёт место в DOM (page-main-view): ниже окон, выше карты */
  z-index: 0;
  display: flex;
  flex-direction: column;
  gap: 11px;
  pointer-events: none;
  & > * {
    pointer-events: auto;
  }
`;

export const DockHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 2px;
  flex: none;
`;
export const DockTitle = styled.span`
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #7a838a;
  font-weight: 600;
`;
export const DockToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 9px;
  border-radius: 8px;
  border: 1px solid #2c353d;
  background: #161e23;
  color: #aab2b8;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;
  &:hover {
    color: #e6eaec;
    border-color: #3d4952;
  }
  svg {
    width: 12px;
    height: 12px;
  }
`;

/* scroll area holding the widget stack */
export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
  scrollbar-width: thin;
  scrollbar-color: #3d4952 transparent;
  &::-webkit-scrollbar {
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    background: #2c353d;
    border-radius: 4px;
  }
`;

const softPulse = keyframes`
  0%, 100% { box-shadow: inset 0 1px 0 rgba(255,255,255,.03), 0 0 0 1px rgba(47,158,196,.32); }
  50%      { box-shadow: inset 0 1px 0 rgba(255,255,255,.03), 0 0 0 1px rgba(47,158,196,.6), 0 0 16px rgba(47,158,196,.32); }
`;

export const Widget = styled.div`
  flex: none;
  background: #161e23;
  border: 1px solid #2c353d;
  border-radius: 12px;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.03),
    0 10px 26px rgba(0, 0, 0, 0.34);
  overflow: hidden;
  &.alert {
    animation: ${softPulse} 2.4s ease-in-out infinite;
    border-color: #2f9ec4;
  }
  &.alert-red {
    border-color: #a83a3a;
  }
  @media (prefers-reduced-motion: reduce) {
    &.alert {
      animation: none;
    }
  }
`;

export const WHead = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #2c353d;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  color: #e6eaec;
  transition: background 0.15s ease;
  &:hover {
    background: #1a2429;
  }
  &.closed {
    border-bottom-color: transparent;
  }
`;
export const WIco = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  flex: none;
  background: #10151a;
  border: 1px solid #2c353d;
  svg {
    width: 15px;
    height: 15px;
    display: block;
  }
`;
export const WTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  flex: 1;
  min-width: 0;
`;
export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  box-sizing: border-box;
  padding: 0 5px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  flex: none;
  &.red {
    background: #cc2936;
  }
  &.amber {
    background: #b8790f;
  }
  &.blue {
    background: #1c6e8c;
  }
  &.ok {
    background: #2f7d52;
  }
  &.ghost {
    background: transparent;
    border: 1px solid #3d4952;
    color: #7a838a;
  }
`;
export const Caret = styled.span`
  flex: none;
  color: #7a838a;
  display: inline-flex;
  svg {
    width: 13px;
    height: 13px;
    transition: transform 0.18s ease;
  }
  &.open svg {
    transform: rotate(180deg);
  }
`;

export const WBody = styled.div`
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 9px;
  background: #12171c;
  border: 1px solid #2c353d;
  font-family: inherit;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
  &[as],
  &:is(button) {
    &:hover {
      background: #172026;
      border-color: #3d4952;
    }
  }
`;
export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
  &.red {
    background: #cc2936;
    box-shadow: 0 0 7px rgba(204, 41, 54, 0.55);
  }
  &.amber {
    background: #e0932f;
    box-shadow: 0 0 7px rgba(224, 147, 47, 0.5);
  }
  &.blue {
    background: #43b6e6;
    box-shadow: 0 0 7px rgba(67, 182, 230, 0.5);
  }
  &.green {
    background: #5cc98a;
    box-shadow: 0 0 7px #316a48a7;
  }
  &.gray {
    background: #777;
    box-shadow: 0 0 7px rgba(62, 62, 62, 0.5);
  }
`;
export const RackId = styled.span`
  font-weight: 600;
  font-size: 12.5px;
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  color: #e6eaec;
  flex: none;
`;
export const Grow = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #aab2b8;
  font-size: 12px;
  text-align: right;
`;
export const RackName = styled(RackId)`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;
export const Status = styled(Grow)`
  flex: none;
`;
export const Wait = styled.span`
  font-size: 12px;
  color: #aab2b8;
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  flex: none;
`;
export const Btns = styled.span`
  display: flex;
  gap: 6px;
  flex: none;
`;

/* call row is stacked: identity line on top, full-width actions below */
export const CallItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 9px 10px;
  border-radius: 9px;
  background: #12171c;
  border: 1px solid #2c353d;
  &.active {
    border-color: #2f9ec4;
    background: #101c22;
  }
`;
export const CallTop = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;
export const CallName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: 600;
  color: #e6eaec;
`;
export const CallActs = styled.div`
  display: flex;
  gap: 7px;
  & > button {
    flex: 1;
    height: 30px;
  }
`;
export const Btn = styled.button`
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  height: 26px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #3d4952;
  background: #1a2429;
  color: #e6eaec;
  cursor: pointer;
  white-space: nowrap;
  transition:
    filter 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease;
  &.ok {
    border-color: transparent;
    color: #fff;
    background: linear-gradient(180deg, #5cc98a, #47b972);
  }
  &.no {
    border-color: transparent;
    color: #fff;
    background: linear-gradient(180deg, #e0555f, #cc2936);
  }
  &:hover {
    filter: brightness(1.06);
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
    filter: none;
  }
`;

/* occupancy */
export const Occ = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 3px 2px;
  border-radius: 8px;
  transition: background 0.15s ease;
  &:hover {
    background: #12171c;
  }
  .zone-icon {
    width: 26px !important;
    height: 26px !important;
    border-radius: 7px !important;
    margin: 0 !important;
    flex: none;
  }
`;
export const Bar = styled.span`
  flex: 1;
  height: 8px;
  border-radius: 5px;
  background: #10151a;
  overflow: hidden;
  border: 1px solid #2c353d;
  i {
    display: block;
    height: 100%;
    border-radius: 5px;
  }
`;
export const OccVal = styled.span`
  font-size: 12px;
  color: #aab2b8;
  width: 64px;
  text-align: right;
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  flex: none;
`;

/* trio stats */
export const Stats = styled.div`
  display: flex;
  gap: 8px;
`;
export const Stat = styled.div`
  flex: 1;
  background: #12171c;
  border: 1px solid #2c353d;
  border-radius: 9px;
  padding: 9px 10px;
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  b {
    font-family: 'IBM Plex Mono', monospace;
    font-variant-numeric: tabular-nums slashed-zero;
    font-size: 20px;
    font-weight: 600;
    display: block;
    line-height: 1;
    color: #e6eaec;
  }
  span {
    font-size: 10.5px;
    color: #7a838a;
    letter-spacing: 0.02em;
  }
  &.ok b {
    color: #5cc98a;
  }
  &.offline b {
    color: #777;
  }
  &.warn b {
    color: #e0932f;
  }
  &.crit b {
    color: #e0555f;
  }
`;

export const PlateTag = styled.span`
  font-weight: 600;
  font-size: 12.5px;
  letter-spacing: 0.06em;
  color: #e6eaec;
  background: #10151a;
  border: 1px solid #3d4952;
  border-radius: 6px;
  padding: 3px 8px;
  flex: none;
`;

export const Empty = styled.div`
  padding: 14px 10px;
  text-align: center;
  color: #5a666d;
  font-size: 12px;
`;
